import {
    SIGN_IN,
    ERROR,
    LOG_OUT,
    LOADING_LOGIN,
    SELECT_COMPANY,
	REFRESH_IDCONNECTION,
	SELECTED_DATE,
    SELECTED_SCALE,
    LOADING_PREFERENCES
} from '../constants';

const initialState = {
    DataCompany: JSON.parse(localStorage.getItem("company-s10")),
    auth: undefined,
	loading: true,
    User: JSON.parse(localStorage.getItem("user-s10")),
    Companies: [],
    Roles: [],
	dateSelected: '',
    scaleSelected: '',
    loadingPreferences: true,
}

const authReducerFn = (state = initialState, { type, payload }) => {
    switch (type) {
        case LOADING_LOGIN:
            return{
                loading: true
            }

        case SIGN_IN:
			localStorage.setItem('user-s10', JSON.stringify(payload));
            return{
                ...state,
				User: payload,
                Companies: payload.Companies,
            }
        case SELECT_COMPANY:
			localStorage.removeItem('company-s10');
            localStorage.setItem('company-s10', JSON.stringify(payload));
            // console.log(payload);
            return {
                ...state,
                DataCompany: payload,
				auth: payload.change === true
            }

        case REFRESH_IDCONNECTION:
            return {
                ...state,
                loading: false,
                auth: payload
            }
		

        case LOG_OUT:
            localStorage.removeItem('company-s10');
			localStorage.removeItem('user-s10');
			localStorage.removeItem('connectionId');
			localStorage.removeItem('header-pc');
			localStorage.removeItem('header-project');
            return{
                ...state,
                auth: false,
                user: null,
                loading: false
            } 

        case ERROR:
            return{
                ...state,
                error: true
            }

		case SELECTED_DATE:
			return{
				...state,
				dateSelected: payload
			}

		case SELECTED_SCALE:
			return{
				...state,
				scaleSelected: payload
			}
		case LOADING_PREFERENCES:
			return{
				...state,
				loadingPreferences: payload
			}
        default:
            return state;
    }
}

export default authReducerFn;